<template>
  <div class="slide flex pt-12 md:pt-16" v-if="planData && planData.length > 0">
    <div class="w-full">
      <div class="muti-slider title-padding-bottom w-full">
        <h1 class="text-center mb-4 md:mb-6 font-bold textColorBlack">{{ title }}</h1>
          <div class="relative w-full h-full">
            <swiper :options="relatedEventsOption" class="swiper w-full h-full">
              <swiper-slide v-for="(item, index) in planData" :key="index">
                <a :href="item.url" target="_blank" class="w-full h-full">
                  <div class="slider-img sm:px-2 flex justify-center w-full">
                    <img class="w-full h-full object-contain" :src="item.image_url" :alt="item.name">
                  </div>
                </a>
              </swiper-slide>
              <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
            <div class="swiper-button-next-events focus:outline-none cursor-pointer hidden sm:block"></div>
            <div class="swiper-button-prev-events focus:outline-none cursor-pointer hidden sm:block"></div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'RelatedEvents',

  props: {
    title: {
      type: String
    }
  },

  data () {
    return {
      planData: [],
      relatedEventsOption: {
        slidesPerView: 3,
        spaceBetween: 10,
        loop: true,
        navigation: {
          nextEl: '.swiper-button-next-events',
          prevEl: '.swiper-button-prev'
        },
        breakpoints: {
          768: {
            slidesPerView: 1
          }
        }
      }
    }
  },
  computed: {
  },
  mounted () {
    this.getData()
  },
  methods: {
    getData () {
      let self = this
      axios.get('/ad/events')
        .then((response) => {
          self.planData = response.data
        })
    }
  }
}
</script>

<style lang="scss" scoped>
    .swiper-container {
      width: 100%;
      height: 100%;
    }
    .swiper-slide {
      text-align: center;
      font-size: 18px;
      background: #fff;

      display: -webkit-box;
      display: -ms-flexbox;
      display: -webkit-flex;
      display: flex;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      -webkit-justify-content: center;
      justify-content: center;
      -webkit-box-align: center;
      -ms-flex-align: center;
      -webkit-align-items: center;
      align-items: center;
    }
  .swiper-button-next-preview-events {
    right: -2rem;
    background-image: url('~@/assets/btn/arrowRight.png');
    background-size: contain;
    width: 30px;
    height: 30px;
    // top: 50%;
    transform: translateY(-50%);
    margin-top: 0 !important;
  }
  .swiper-button-prev-preview-events {
    left: -2rem;
    background-image: url('~@/assets/btn/arrowLeft.png');
    background-size: contain;
    width: 30px;
    height: 30px;
    // top: 50%;
    transform: translateY(-50%);
    margin-top: 0 !important;
  }
</style>
